import React from "react";

// Importing react router dom
import { useLocation } from "react-router-dom";

import { useSelector } from "react-redux";

import GeneralAccessManagement from "./GeneralAccess";
import EmployeesViewManagement from "./View";

// Import utilities
import { isAllowedToDo, isAllowedToDoByKey } from "permissions-hub";
import {
  DESIGNATION_MANAGEMENT,
  TEAM_MANAGEMENT,
  SHIFT_MANAGEMENT,
  ROLE_MANAGEMENT,
  ACCEPTED_PERMISSIONS,
} from "constants";
import { getAllowedPermissions } from "utils/authentication";

// Importing common components
import WarningAlert from "common/Alert";

const EmployeeManagement = ({ permissions, isRoleAdmin, isRoleTeamWise }) => {

  // Get Search params
  const location = useLocation();
  const searchEmployeeParams = new URLSearchParams(location.search);
  const teamId = searchEmployeeParams.get("q") || "";
  const _ehphide = searchEmployeeParams.get("_ehphide") || "";

  const { userInfo: loggedUserInfo } = useSelector((state) => state.auth);

  // ?? Check 'Read' permission of designation, team, shift & role management.

  // Check read permission of designation
  const isAllowedToReadDesignation = isAllowedToDoByKey(
    DESIGNATION_MANAGEMENT,
    ACCEPTED_PERMISSIONS["read"],
    getAllowedPermissions(loggedUserInfo),
    false
  );

  const isAllowedToReadTeam = isAllowedToDoByKey(
    TEAM_MANAGEMENT,
    ACCEPTED_PERMISSIONS["read"],
    getAllowedPermissions(loggedUserInfo),
    false
  );

  const isAllowedToReadShift = isAllowedToDoByKey(
    SHIFT_MANAGEMENT,
    ACCEPTED_PERMISSIONS["read"],
    getAllowedPermissions(loggedUserInfo),
    false
  );

  const isAllowedToReadRole = isAllowedToDoByKey(
    ROLE_MANAGEMENT,
    ACCEPTED_PERMISSIONS["read"],
    getAllowedPermissions(loggedUserInfo),
    false
  );

  // ?? Check permission of employee management

  // Check read permission
  const isAllowedToRead = isAllowedToDo(
    ACCEPTED_PERMISSIONS["read"],
    permissions
  );

  // Check create permission
  const isAllowedToCreate = isAllowedToDo(
    ACCEPTED_PERMISSIONS["create"],
    permissions
  );

  // Check update permission
  const isAllowedToUpdate = isAllowedToDo(
    ACCEPTED_PERMISSIONS["update"],
    permissions
  );

  // Check delete permission
  const isAllowedToDelete = isAllowedToDo(
    ACCEPTED_PERMISSIONS["delete"],
    permissions
  );

  // Pass EmployeesViewManagement as a prop if isGeneralAccess is true
  if (
    isAllowedToRead &&
    (isAllowedToCreate || isAllowedToUpdate || isAllowedToDelete)
  ) {
    const ManagementComponent = (
      <GeneralAccessManagement
        teamId={teamId}
        _ehphide={_ehphide}
        isAllowedToCreate={isAllowedToCreate}
        isAllowedToUpdate={isAllowedToUpdate}
        isAllowedToDelete={isAllowedToDelete}
        EmployeesViewManagement={EmployeesViewManagement}
      />
    );

    return !(
      isAllowedToReadDesignation &&
      isAllowedToReadTeam &&
      isAllowedToReadShift &&
      isAllowedToReadRole &&
      (isRoleAdmin || isRoleTeamWise)
    ) ? (
      <WarningAlert
        message="<p>In order to effectively manage the system, you need to have read permissions for <strong>Designation, Team, Shift, and Role management</strong>. If you are an administrator, you can enable these permissions from the role management section.</p>
          <hr/> <p class='mb-0'>If you need further assistance, please contact the developer at <a href='mailto:ankitbattersea@gmail.com' >ankitbattersea@gmail.com</a>.</p>"
      />
    ) : (
      ManagementComponent
    );
  } else if (
    isAllowedToRead &&
    !(isAllowedToCreate || isAllowedToUpdate || isAllowedToDelete)
  ) {
    return <EmployeesViewManagement />;
  }
};

export default EmployeeManagement;
